import { Plugins } from '@leverege/plugin';
function addToType(typeMap, type, aggregation) {
  const arr = typeMap.get(type);
  if (arr == null) {
    typeMap.set(type, [aggregation]);
  } else {
    arr.push(aggregation);
  }
}
function addAggregations(typeMap, aggregations) {
  for (let n = 0; n < aggregations.length; n++) {
    const aggregation = aggregations[n];
    const {
      objectType
    } = aggregation;
    if (objectType != null) {
      if (Array.isArray(objectType)) {
        objectType.forEach(type => {
          addToType(typeMap, type, aggregation);
        });
      } else {
        addToType(typeMap, objectType, aggregation);
      }
    } else {
      addToType(typeMap, 'default', aggregation);
    }
  }
}
function processor(aggregations) {
  const types = new Map(); // name:type -> detail lookup

  addAggregations(types, aggregations.map(aggregation => aggregation.model));

  // Add any details available from a a creator
  //   const creators = Plugins.get( 'AggregationCreator' )
  //   creators.forEach( ( creator ) => {
  //     const aggregations = creator.create( )
  //     addAggregations( types, aggregations )
  //   } )

  return {
    types
  };
}
const view = Plugins.createView('AggModel', {
  processor
});
function getAggregationsFor(type) {
  const {
    types
  } = view.get();
  const defaultTypes = types.get('default');
  const typeTypes = types.get(type);
  const ret = [];
  if (defaultTypes) ret.push(...defaultTypes);
  if (typeTypes) ret.push(...typeTypes);
  return ret;
}
export default {
  getAggregationsFor
};